module.exports = __webpack_public_path__ + "static/media/1021793.272de407.jpg";